import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import FacebookIcon from '@mui/icons-material/Facebook';
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";


// About Us page sections
import Information from "pages/LandingPages/AboutUs/sections/Information";
import Team from "pages/LandingPages/AboutUs/sections/Team";
import Newsletter from "pages/LandingPages/AboutUs/sections/Newsletter";
import Formation from "./sections/Formation";

// Routes

function AboutUs() {
  const bg = "https://images.pexels.com/photos/33607952/pexels-photo-33607952.png"
  return (
    <>

      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              À propos de moi
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Je suis un passionné du développement et de la création digitale.
              J’aime concevoir des projets modernes et fonctionnels qui allient simplicité, efficacité et créativité.
              Mon objectif est de donner vie aux idées et de transformer les visions en expériences uniques.
            </MKTypography>

            <MKButton
              component="a"
              href="https://www.facebook.com/sharer/sharer.php?u=https://rakotozafy.varcel.app"
              target="_blank"
              color="default"
              sx={{ color: ({ palette: { dark } }) => dark.main }}
            >
              <FacebookIcon /> Partager
            </MKButton>


          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Information />

        <Formation />
        <Team />
        <Newsletter />

      </Card>

    </>
  );
}

export default AboutUs;
